import { IPolicyAdminProvider } from "../interfaces/IPolicyAdminProvider";
import {
  Application,
  ApplicationDocument,
  PolicyAdminProviderConfig,
} from "../types/PolicyAdmin.types";
import { Result } from "@badrap/result";

export class RISEProvider implements IPolicyAdminProvider {
  private config: PolicyAdminProviderConfig;

  constructor(config: PolicyAdminProviderConfig) {
    this.config = config;
  }

  async getApplicationById(id: string): Promise<Result<Application, Error>> {
    return Result.err(new Error("RISEProvider getApplicationById not implemented"));
  }

  async getDocuments(objectId: string): Promise<Result<ApplicationDocument[], Error>> {
    return Result.err(new Error("RISEProvider getDocuments not implemented"));
  }

  getProviderName(): string {
    return "RISE";
  }
}
